<template>
  <div id="pay2" class="container" style="padding-top:40px;">
    <div class="row">
      <el-row :gutter="40">
        <el-col :span="2" class="icon">
          <i class="far fa-check-circle fa-5x"></i>
        </el-col>
        <el-col :span="17">
          <div class="text1">订单提交成功！我们会尽快安排发货。</div>
          <span v-show="id" class="lv3Text">订单编号：</span>
          <span v-show="id" class="lv2Text">{{id}}</span>
          <span style="margin-left:10px">
            <router-link
              to="/user/orders/1"
              class="link"
              style="color: #e2211c;text-decoration: underline;"
            >查看订单</router-link>
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      payType: null,
      id: this.$route.query.order,
      ids:this.$route.query.orders,
      loading: false
    };
  },
  watch: {},
  created() {
    //
  },
  methods: {
    //
    goToPay() {
      if (this.payType == 2) {
        this.axios
          .get(this.serve + "/member/weChatPay", {
            params: {
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token"),
              orderCode: this.id,
              payway: "3"
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$router.push(
                "/user/weChatPayQRcode?qr=" +
                  encodeURIComponent(res.data.data) +
                  "&order=" +
                  this.id
              );
            }
          });
      } else if (this.payType == 1) {
        window.location.href =
          this.serve + "/member/AliPays?mobile=" +
          this.mobile +
          "&token=" +
          this.token +
          "&orderCode=" +
          this.id +
          "&payway=2";
      }
    }
  }
};
</script>
<style lang="scss">
#pay2 {
  .link:hover {
    text-decoration: underline;
  }
  .text1 {
    font-size: 22px;
    font-weight: bold;
    padding: 10px 0;
  }
  .text2 {
    color: #999;
  }
  .icon svg {
    color: #e2211c;
  }
  .text3 {
    color: #e2211c;
  }
  .submit {
    margin-top: 20px;
    width: 150px;
  }
  .row {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 40px 100px;
    margin-bottom: 40px;
  }

  .row2 {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 40px;
    .underline {
      padding: 20px 0;
    }
  }
  .underline {
    border-bottom: 1px solid #ddd;
  }
  .underline2 {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }
  padding-bottom: 40px;
}
</style>